<template>
  <form @submit.prevent="validateAndSubmit">
    <div class="row">
      <div class="col col-md-6 col-12">
        <div class="form-group">
          <label for="assesmentName">Side Effects/Symptoms Name</label>
          <b-form-input
            v-model="assessment.name"
            :disabled="disabled"
            v-validate="'required'"
            :class="{'danger': errors.has('assesmentName') }"
            name="assesmentName"
            type="text"
            placeholder="eg Pain"
          />
        </div>
      </div>
      <div class="col col-md-6 col-12">
        <div class="form-group">
          <label for="assesmentTarget">Side Effects/Symptoms Target/Time</label>
          <b-form-input
            v-model="assessment.target_or_time"
            :disabled="disabled"
            v-validate="'required'"
            :class="{'danger': errors.has('assesmentTarget') }"
            name="assesmentTarget"
            type="text"
            placeholder="eg Lower back"
          />
        </div>
      </div>
      <div class="row col col-md-12 col-12 d-flex justify-content-between align-itemns-center">
        <div class="col col-md-4 col-6">
          <v-time-picker
            @onChange="(value) => assessment.start_time = value"
            class="`form-group`"
            :disabled="disabled"
            :maxTime="assessment.end_time"
            :label="`Start Time`"
            :className="{'danger': errors.has('startTime') }"
            name="startTime"
            :value="assessment.start_time"
            v-validate="`required|maxTime:${'Start Time'},${assessment.end_time}`"
          />
        </div>
        <div class="col col-md-4 col-6">
          <v-time-picker
            @onChange="(value) => assessment.end_time = value"
            :disabled="disabled"
            :minTime="assessment.start_time"
            :label="`End Time`"
            :className="{'danger': errors.has('endTime') }"
            :value="assessment.end_time"
            name="endTime"
            v-validate="`required|minTime:${'End Time'},${assessment.start_time}`"
          />
        </div>
        <div class="col col-md-4 col-12">
          <div class="form-group">
            <label for="prompt_time">Prompt Every</label>
            <div class="d-flex justify-content-between align-itemns-center">
              <b-form-input
                v-model.number="assessment.prompt_time"
                :disabled="disabled"
                v-validate="'required'"
                :class="{'danger': errors.has('prompt_time') }"
                name="prompt_time"
                type="number"
                :min="0"
                placeholder="eg 5"
              />mins
            </div>
          </div>
        </div>
      </div>
      <div class="col col-md-12 col-12 error-text">
        {{ errors.first('endTime') || errors.first('startTime') }}
      </div>
     <div class="row no-gutters col-12 pb-1">
          <b-form-checkbox v-model="assessment.is_trigger" name="trigger action" :disabled="disabled">is Trigger</b-form-checkbox>
      </div>
      <div class="col col-md-12 col-12">
        <div class="form-group">
          <label for="input_type">Input Type</label>
          <b-form-select
            v-model="assessment.input_type"
            :disabled="disabled"
            v-validate="'required'"
            :class="{'danger': errors.has('input_type') }"
            :options="inputTypeOptions"
            name="input_type"
            @change="onChangeInputType"
          />
        </div>
      </div>
      <div class="col col-md-12 col-12" v-if="!isInputTypeSideEffectsPicker">
        <div class="form-group">
          <label
            class="col-12 p-0"
            for="question"
          >Question</label>
          <b-form-input
            v-model="assessment.question"
            :disabled="disabled"
            v-validate="'required'"
            :class="{'danger': errors.has('question') }"
            name="question"
            type="text"
            placeholder="eg How was your pain today?"
          />
        </div>
      </div>
      <div class="col col-md-7 col-12" v-if="isInputTypeBoolean">
          <div class="form-group">
            <label
              class="col-12 p-0"
              for="question"
            >Side Effects/Symptoms Description</label>
            <b-form-input
              v-model="assessment.description"
              :disabled="disabled"
              v-validate="'required'"
              :class="{'danger': errors.has('description') }"
              name="description"
              type="text"
              placeholder="eg Please select Yes or No"
            />
        </div>
      </div>
      <div class="col col-md-5 col-12" v-if="isInputTypeBoolean">
        <div class="form-group">
          <label for="threshold">Threshold</label>
          <b-form-select
            v-model="assessment.threshold"
            :disabled="disabled"
            v-validate="'required'"
            :class="{'danger': errors.has('threshold') }"
            :options="booleanTypeOptions"
             name="threshold"
          />
        </div>
      </div>
       <div class="col col-md-6 col-12" v-if="isInputTypeBoolean">
          <div class="form-group">
            <label
              class="col-12 p-0"
              for="question"
            >True Display Text</label>
            <b-form-input
              v-model="assessment.positve_label"
              :disabled="disabled"
              v-validate="'required'"
              :class="{'danger': errors.has('positve_label') }"
              name="positve_label"
              type="text"
              placeholder="eg Yes"
            />
        </div>
      </div>
      <div class="col col-md-6 col-12" v-if="isInputTypeBoolean">
        <div class="form-group">
          <label for="input_type">False Display Text</label>
          <b-form-input
              v-model="assessment.negative_label"
              :disabled="disabled"
              v-validate="'required'"
              :class="{'danger': errors.has('negative_label') }"
              name="negative_label"
              type="text"
              placeholder="eg No"
            />
        </div>
      </div>
      <div class="col col-md-12 col-12" v-if="!isInputTypeBoolean && !isInputTypeSideEffectsPicker">
        <div class="pain-content">
          <div class="col col-md-12 col-12 gradient" />
          <div class="d-flex justify-content-between align-itemns-center">
            <div class="col col-md-3 col-3">
              <div class="form-group">
                <b-form-input
                  v-model.number="assessment.min"
                  :disabled="disabled"
                  v-validate="`required|${isInputTypeText ? 'decimal:1' : 'numeric'}`"
                  :min="0"
                  :class="{'danger': errors.has('Minimum') }"
                  name="Minimum"
                  type="number"
                  placeholder="eg 1234"
                />
                <label for="pain-min">Min</label>
              </div>
            </div>
            <div class="col col-md-3 col-3">
              <div class="form-group">
                <b-form-input
                  v-model.number="assessment.threshold"
                  :disabled="disabled"
                  v-validate="`${isInputTypeText ?
                  'decimal:1' : 'numeric'}|required|between:${assessment.min},${assessment.max}`"
                  :min="0"
                  :class="{'danger': errors.has('Threshold') }"
                  name="Threshold"
                  type="number"
                  placeholder="eg 8"
                />
                <label for="Threshold">Threshold</label>
              </div>
            </div>
            <div class="col col-md-3 col-3">
              <div class="form-group">
                <b-form-input
                  v-model.number="assessment.max"
                  :disabled="disabled"
                  v-validate="`${isInputTypeText ?
                  'decimal:1' : 'numeric'}|required|min_value:${assessment.threshold}`"
                  :min="0"
                  :class="{'danger': errors.has('Maximum') }"
                  name="Maximum"
                  type="number"
                  placeholder="eg 10"
                />
                <label for="Maximum">Max</label>
              </div>
            </div>

          </div>
          <div class="col col-md-12 col-12 error-text">
            {{
              errors.first('Minimum') || errors.first('Maximum')
                || errors.first('Threshold')
            }}
          </div>
        </div>
      </div>
      <div class="col col-md-6 col-12" v-show="!isInputTypeBoolean && !isInputTypeSideEffectsPicker">
        <div class="form-group">
          <label
            class="col-12 p-0"
            for="label_min"
          >Label (min)</label>
          <b-form-input
            v-model="assessment.label_min"
            :disabled="disabled"
            v-validate="isInputTypeBoolean ||  isInputTypeSideEffectsPicker ? '' : 'required'"
            :class="{'danger': errors.has('label_min') }"
            name="label_min"
            type="text"
            placeholder="eg Not at all"
          />
        </div>
      </div>
      <div class="col col-md-6 col-12" v-show="!isInputTypeBoolean && !isInputTypeSideEffectsPicker">
        <div class="form-group">
          <label
            class="col-12 p-0"
            for="assesmentTarget"
          >Label (max)</label>
          <b-form-input
            v-model="assessment.label_max"
            :disabled="disabled"
            v-validate="isInputTypeBoolean || isInputTypeSideEffectsPicker ? '' : 'required'"
            :class="{'danger': errors.has('label_max') }"
            name="label_max"
            type="text"
            placeholder="eg Very much"
          />
        </div>
      </div>
      <div class= "col col-12 multi-select-table" :class="{'prevent-row-click': actionType === 'View'}" v-show="isInputTypeSideEffectsPicker">
        <div class="form-group">
          <label for="symptoms" class="col-12 p-0">Symptoms</label>
          <span class="error-text text-left" v-if="!isEmpty(selectedAssessmentSymptom) && isSubmitted">Select atleast one field</span>
        </div>
        <v-multi-select-table
          :selectedSymptoms="assessment.careplanAssessmentSymptoms ? assessment.careplanAssessmentSymptoms : []"
          :actionType="actionType"
          @selectedItems="getSelectedSymptoms"
          ref="assessmentSymptomsTable"
          >
        </v-multi-select-table>
      </div>
    </div>
  </form>
</template>

<script>
import actions from '@/constants/_actions';
import VMultiSelectTable from "@/components/table/MultiSelect/index.vue";


export default {
  name: 'Assessment',
  components: {
    VMultiSelectTable
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    actionType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      assessment: this.data,
      isSubmitted: false,
      selectedAssessmentSymptom: [],
      inputTypeOptions: [
        {
          text: 'Slider',
          value: 'Slider'
        },
        {
          text: 'Picker',
          value: 'Picker'
        },
        {
          text: 'Text',
          value: 'Text'
        },
        {
          text: 'Boolean',
          value: 'Boolean'
        },
        {
          text: 'SideEffect Picker',
          value: 'MultipleChoice'
        }
      ],
      booleanTypeOptions: [
        {
          text:'True',
          value:'1'
        },
        {
          text:'False',
          value:'0'
        },
      ],
      fields: [{ key: 'id', label: 'SelectAll' }, { key: 'name', label: 'Options' }],
    };
  },
  computed: {
    isInputTypeText() {
      return this.assessment.input_type === 'Text';
    },
    isInputTypeBoolean() {
      return this.assessment.input_type === 'Boolean';
    },
    isInputTypeSideEffectsPicker() {
      return this.assessment.input_type === 'MultipleChoice';
    },
    disabled() {
      return this.actionType === actions.VIEW;
    }

  },
  beforeMount() {
    this.$store.dispatch('assessments/getAssessmentSymptoms');
  },
  mounted(){
    if(!this.data.threshold){
      this.data.threshold = 0;
    }
  },
  methods: {
    validateAndSubmit() {
      this.isSubmitted = true;
      this.$validator.validateAll().then((result) => {
        this.assessment.careplan_id = this.$store.state.careplan.careplan.id;
        if (this.assessment.input_type === 'MultipleChoice' && this.selectedAssessmentSymptom.length === 0) {
          return;
        }
        if (result) {
          if (this.actionType === actions.EDIT && this.assessment.careplanAssessmentSymptoms && this.assessment.careplanAssessmentSymptoms.length !== 0) {
              delete this.assessment.careplanAssessmentSymptoms;
          }
          this.assessment.choices = this.selectedAssessmentSymptom.map((symptom) => {
            return symptom.id
          });
          this.$emit('onSubmit', this.assessment);
          this.isSubmitted = false;
        }
      });
    },
    onChangeInputType() {
      this.$refs.assessmentSymptomsTable.unselectAllRows();
    },
    getSelectedSymptoms(items) {
      this.selectedAssessmentSymptom = items;
    }
  }
};
</script>

<style lang="scss" scoped>
 @import './style.scss';
</style>
